import { render, staticRenderFns } from "./SimpleField.vue?vue&type=template&id=02c148a0&scoped=true"
import script from "./SimpleField.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleField.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c148a0",
  null
  
)

export default component.exports